export class Adquirente {
  public AdquirenteId = '';
  public Nome = '';
  public ContaId = '';
  public GatewayId = '';
  public GatewayKey = '';
  public UrlRequicisao = '';
  public UrlConsulta = '';
  public TipoMeioPagamento = '';
  public MeioPagamento = '';
  public Padrao = false;
  public Validacao: any;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/adquirente.ts